export default function getUnreadItemClass(itemProps, tableProps, isChecked, unreadClass, // Class to be applied when item is unread
darkerUnreadClass // Class to be applied when item is unread (and has non-default background color)
) {
    var isSelected = itemProps.isSelected, isFlagged = itemProps.isFlagged, isPinned = itemProps.isPinned;
    var supportsFlagging = tableProps.supportsFlagging, supportsPinning = tableProps.supportsPinning;
    // Determine item state by checking item and table properties.
    var isItemSelected = isSelected || isChecked;
    var isItemFlagged = supportsFlagging && isFlagged;
    var isItemPinned = supportsPinning && isPinned;
    /**
     * If item is in a state with a non-default background color, return
     * darkerUnreadClass (which should set font color to be darker than unreadClass
     * does).
     */
    if (isItemSelected || isItemFlagged || isItemPinned) {
        return darkerUnreadClass;
    }
    // If item is unread and without any special state, return unreadClass.
    return unreadClass;
}
//# sourceMappingURL=getUnreadItemClass.js.map